module.exports = __webpack_public_path__ + "img/2_1-parco-0.608f7633.png";